import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';

import { OpcionModel } from '../Global/Opcion.model';
import {FacturacionElectronicaConsultarModel} from './FacturacionElectronicaConsultarPdfModel';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { MatSnackBar } from '@angular/material';


@Component({
	selector: 'consultarPdf',
	templateUrl: './ConsultarPdf.component.html',
	styleUrls: ['../../../../styles.css']
})

/**
* @author Camilo
* @since  01/10/2018
**/
export class FacturacionElectronicaConsultarPdfComponent {

	public form: FormGroup;
	public formErrors: any;

	public prefijoNumero: string;
	public tipo: string;
	public negocio: string;

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;
	

	public btnConsultar: boolean;


	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
	}


	ngOnInit() {
		this.inicializarForm();
	}


	inicializarForm() {
		this.formErrors = {
			prefijoNumero: {},
			tipo: {},
			negocio: {}
		};


		this.form = this.formBuilder.group({
			prefijoNumero: ['', Validators.required],
			tipo: ['', Validators.required],
			negocio: ['', Validators.required]
		});
	}




	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	consultar() {
		

		this._serviciosGenerales.get('validarContrato', { negocio:this.negocio }).subscribe(res => {
			//console.log("----->----------<------------>-----------> ",res);
			if(res[0].cantidad>0){
				let parametros = { prefijoNumero: this.prefijoNumero.toUpperCase(), tipo: this.tipo, negocio: this.negocio };
				this._serviciosGenerales.descargarArchivo('servicioFacturacionElectronica/generar/pdf', parametros);
				/*this._serviciosGenerales.get('servicioFacturacionElectronica/generar/pdf', parametros).subscribe(
					result => {
						console.log('',result);
						try{
							var blob=new Blob([result]);
							var link=document.createElement('a');
							link.href=window.URL.createObjectURL(blob);
							link.download="prueba.pdf";
							link.click();
						}catch(e){
							console.log(e);
						}
					}, error => {
						console.log(error);
					}
				)*/	
			}
			else{
				this.openSnackBar("El contrato "+this.negocio+" No esta asociado al Usuario","X");
			}
		}, error => {
			this.openSnackBar("El contrato "+this.negocio+" No esta asociado al Usuario","X");
			console.log(error, '');
		})

	}



}





// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/FacturacionElectronicaDescargarImagen/FacturacionElectronicaConsultarPdf.component.ts